import React from 'react';
import ChefsAndRestaurants from '../../components/ChefsAndRestaurants';

const ChefsAndRestaurantsPage = (props) => {
  const { classes } = props;
  return (
    <div className={classes.wrap}>
      <ChefsAndRestaurants onView={() => props.history.push('restaurants/10') }/>
    </div>
  );
};

export default ChefsAndRestaurantsPage;
